function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import * as React from "react";
import { clsx } from "clsx";
import isNil from "lodash/isNil";
import queryString from "query-string";
import { ButtonReact } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { SpinnerReact } from "common/components/spinner";
import { QueryReportHeaderReact } from "common/query-builder/query-report-header";
import { QueryReportTitleReact } from "common/query-builder/query-report-title";
import { ModalReact } from "common/components/modal";
import { Placement } from "common/components/tooltip/types";
import { BrowseReact } from "common/widgets/browse";
import { GlobalFilterBar } from "apps/boards/src/dashboards-app/components/global-filter-bar";
import { GridLayoutReact } from "apps/boards/src/dashboards-app/components/grid-layout";
import { ReportEditorReact } from "common/report-editor";
import { TemplateType } from "common/report/dashboards/types";
import { Visibility } from "common/components/base/stackable";
import { isStagedCardId } from "common/report/dashboards/url";
import { BrowseMode } from "common/widgets/browse/types";
import { MAX_DATA_HISTORY_DAYS_UPGRADE_LIMIT } from "common/report/constants";
import { BackboneStyleRoutes } from "common/contexts/react/react-router";
import { BoardsTemplateModalReact } from "apps/boards/src/dashboards-app/components/boards-template-modal";
import { getRouteToCurrentDashboard } from "common/report/util/boards";
import { headerParamsToTitleProps } from "common/query-builder/query-report-title/utils";
import { RHSPanelReact } from "common/widgets/rhs-panel";
import { RHSPanelMode } from "common/widgets/rhs-panel/types";
import { BannerLayout } from "iron/common/report/layout/banner-layout";
import { useTranslation } from "common/i18n/hooks";
import { ReactErrorBoundary } from "common/components/react-error-boundary";
import { StarterBoardModal } from "../starter-board/starter-board-modal";
import { BenchmarkTemplateBanner } from "../components/benchmark-template-banner";
import { GridCell } from "./grid-cell";
import { EmptyHero } from "./empty-hero";
function DashboardHeader(_ref) {
  let {
    queryReportHeaderParams,
    queryReportHeaderExtraTrackingParams,
    onHeaderActionClick,
    onHeaderSave
  } = _ref;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(QueryReportHeaderReact, { ...queryReportHeaderParams, extraTrackingParams: queryReportHeaderExtraTrackingParams, onActionclick: onHeaderActionClick, onSave: (ev) => onHeaderSave(ev.detail), "data-sentry-element": "QueryReportHeaderReact", "data-sentry-source-file": "template.tsx" }));
}
function FilterBar(_ref2) {
  let {
    maxHistoryDays,
    canUseDataGroups,
    canUseCohorts,
    areFiltersChanged,
    canEditActiveDashboard,
    isMinimalMode,
    filters,
    breakdowns,
    timeFilter,
    projectId,
    workspaceId,
    userId,
    projectAsOfDate,
    onChangeGlobalTimeFilter,
    onChangeGlobalFilters,
    onChangeGlobalBreakdowns,
    onClearGlobalTimeFilter,
    onTrackGlobalFilters,
    onDiscardBoardsFilters,
    onSaveBoardsFilters
  } = _ref2;
  const {
    t
  } = useTranslation();
  const showResetButton = !canEditActiveDashboard;
  return /* @__PURE__ */ React.createElement("div", { className: "global-filter-container", "data-sentry-component": "FilterBar", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ React.createElement(
    GlobalFilterBar,
    {
      canClearTime: true,
      canUseDataGroups,
      filters: filters || [],
      breakdowns: breakdowns || [],
      hideAddFilters: isMinimalMode,
      maxFilters: 3,
      maxHistoryDays,
      projectAsOfDate: projectAsOfDate || "",
      projectHasCohorts: canUseCohorts,
      projectId,
      showUpsell: maxHistoryDays < MAX_DATA_HISTORY_DAYS_UPGRADE_LIMIT,
      timeFilter: timeFilter || {},
      trackName: "dashboards",
      userId,
      workspaceId,
      onChangeFilters: onChangeGlobalFilters,
      onChangeBreakdowns: onChangeGlobalBreakdowns,
      onChangeTimeFilter: onChangeGlobalTimeFilter,
      onClearTimeFilter: onClearGlobalTimeFilter,
      onTrack: onTrackGlobalFilters,
      "data-sentry-element": "GlobalFilterBar",
      "data-sentry-source-file": "template.tsx"
    }
  ), !isMinimalMode && /* @__PURE__ */ React.createElement("div", { className: "global-filter-actions" }, areFiltersChanged && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ButtonReact, { className: "global-filter-discard-button", elref: "discardFilters", theme: showResetButton ? ButtonTheme.Secondary : ButtonTheme.Tertiary, onClick: onDiscardBoardsFilters }, t(showResetButton ? "common.reset" : "common.cancel")), canEditActiveDashboard && /* @__PURE__ */ React.createElement("div", { className: "global-filter-save-button-wrapper" }, /* @__PURE__ */ React.createElement(ButtonReact, { elref: "saveFilters", theme: ButtonTheme.Primary, tooltip: {
    text: t("boards.tooltip.save-to-board"),
    placement: Placement.Bottom
  }, onClick: onSaveBoardsFilters }, t("common.save"))))));
}
function GridRows(_ref3) {
  let {
    dashboard,
    dashboardLoaded,
    projectId,
    workspaceId,
    userId,
    isLayoutBeingUpdated,
    canEditActiveDashboard,
    onGridInsert,
    gridLayout,
    cards,
    getDashboardCardComponentOptions,
    getSparkCardComponentOptions,
    onLayoutUpdate,
    onContentAction,
    onOpenFoundationalTemplateModalClicked,
    onGridTrackEvent,
    seenCards,
    isRHSHoverOnly
  } = _ref3;
  const {
    id,
    title
  } = dashboard;
  if (!dashboardLoaded) {
    return /* @__PURE__ */ React.createElement(SpinnerReact, null);
  }
  return /* @__PURE__ */ React.createElement("div", { elref: "gridLayoutContainer", className: "grid-layout ".concat(isRHSHoverOnly ? "disable-click" : ""), "data-sentry-component": "GridRows", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ React.createElement(GridLayoutReact, { canEdit: canEditActiveDashboard, cellRenderer: GridCell({
    cards,
    getSparkCardComponentOptions,
    getDashboardCardComponentOptions,
    seenCards,
    hideNoDataFooter: dashboard.template_type === TemplateType.STARTER_BOARD || isRHSHoverOnly,
    isRHSHoverOnly
  }), dashboardInfo: {
    id,
    title
  }, elref: "gridLayoutEl", gridLayout, ref: (el) => onGridInsert(el), isLayoutBeingUpdated, projectId, userId, workspaceId, onContentAction: (ev) => onContentAction(ev.detail), onLayoutUpdate, onTrackEvent: onGridTrackEvent, emptyRenderer: (_ref4) => {
    let {
      onContentAdded
    } = _ref4;
    return EmptyHero({
      dashboard,
      projectId,
      userId,
      workspaceId,
      onOpenFoundationalTemplateModalClicked,
      onContentAdded
    });
  }, "data-sentry-element": "GridLayoutReact", "data-sentry-source-file": "template.tsx" }));
}
function Modals(_ref5) {
  let {
    templateModalLoading,
    onCancelTemplateModal,
    projectId,
    openCreateFoundationalTemplateModal,
    trackFoundationalTemplateEvent,
    userEmail,
    isOnStarterBoardWithData,
    projectUserCount,
    onCreateBlueprint,
    location
  } = _ref5;
  const queryParams = queryString.parse(location.search);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, (openCreateFoundationalTemplateModal || (queryParams === null || queryParams === void 0 ? void 0 : queryParams["show-template-selector"]) === "true") && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ModalReact, { className: "boards-template-modal", open: true, closeable: true, hideCloseButton: false, onChange: (_ref6) => {
    let {
      detail
    } = _ref6;
    return detail.state === Visibility.Closed && onCancelTemplateModal();
  } }, /* @__PURE__ */ React.createElement(BoardsTemplateModalReact, { loading: templateModalLoading, onTrackEvent: trackFoundationalTemplateEvent, onCreateBlueprint }))), /* @__PURE__ */ React.createElement(StarterBoardModal, { userEmail, projectId, isOnStarterBoardWithData, projectUserCount, "data-sentry-element": "StarterBoardModal", "data-sentry-source-file": "template.tsx" }));
}
export function template() {
  const {
    browseParams,
    dashboard,
    dashboardFailed,
    dashboardLoaded,
    editorCardBookmarkURLSlug,
    editorCardId,
    foregroundQueryResults
  } = this.state;
  const renderDashboardHeader = () => {
    return /* @__PURE__ */ React.createElement(DashboardHeader, { queryReportHeaderParams: this.buildQueryReportHeaderParams(), queryReportHeaderExtraTrackingParams: this.getExtraTrackingParams(), onHeaderActionClick: this.handleHeaderActionClick, onHeaderSave: this.handleHeaderSave, "data-sentry-element": "DashboardHeader", "data-sentry-component": "renderDashboardHeader", "data-sentry-source-file": "template.tsx" });
  };
  const renderRHSPanel = () => {
    const showStarterBoardRHSPanel = () => {
      return Boolean(!(browseParams !== null && browseParams !== void 0 && browseParams.isBrowseMode) && (dashboard === null || dashboard === void 0 ? void 0 : dashboard.template_type) === TemplateType.STARTER_BOARD && !this.hasImplementedData());
    };
    const showTemplateRHSPanel = () => {
      return !(browseParams !== null && browseParams !== void 0 && browseParams.isBrowseMode) && this.state.showTemplateRHS;
    };
    if (showStarterBoardRHSPanel()) {
      return /* @__PURE__ */ React.createElement(RHSPanelReact, { mode: RHSPanelMode.StarterBoard });
    } else if (showTemplateRHSPanel()) {
      return /* @__PURE__ */ React.createElement(RHSPanelReact, { className: "rhs-templates-shadow", onUpdateBlueprint: this.updateBlueprint, onCommitBlueprint: this.commitBlueprint, onClickSeeAllTemplates: this.handleClickSeeAllTemplates, onClick: this.hideRHSReminderTooltip, mode: RHSPanelMode.Templates, selectedTemplate: dashboard === null || dashboard === void 0 ? void 0 : dashboard.template_type, isLoading: this.state.isCommittingBlueprint, isSeeAllTemplatesLoading: this.state.isSeeAllTemplatesLoading, showReminderTooltip: this.state.showRHSReminderTooltip });
    }
    return null;
  };
  const renderDashboardContent = () => {
    return /* @__PURE__ */ React.createElement("div", { className: clsx({
      "low-opacity": this.shouldLowerBoardOpacity()
    }), "data-sentry-component": "renderDashboardContent", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ React.createElement(Modals, { projectId: this.props.context.projectId, templateModalLoading: this.state.templateModalLoading, onCancelTemplateModal: this.handleCancelTemplateModal, openCreateFoundationalTemplateModal: this.state.openCreateFoundationalTemplateModal, trackFoundationalTemplateEvent: this.trackFoundationalTemplateEvent, userEmail: this.props.context.userEmail, isOnStarterBoardWithData: this.isOnStarterBoardWithData(), projectUserCount: this.projectUserCount(), onCreateBlueprint: this.createBlueprintBoard, location: this.props.location, "data-sentry-element": "Modals", "data-sentry-source-file": "template.tsx" }), browseParams !== null && browseParams !== void 0 && browseParams.isBrowseMode ? /* @__PURE__ */ React.createElement(BrowseReact, { projectId: this.props.context.projectId, userId: this.props.context.userId, entityTypeFilter: browseParams.entityTypeFilter, eventNameFilter: browseParams.eventNameFilter, searchText: !isNil(browseParams.searchText) ? browseParams.searchText : this.props.globalSearchController.getSearchedText(), onSearchedTextUpdate: this.handleBrowseSearchedTextUpdate, creatorFilter: browseParams.emailFilter, mode: BrowseMode.Discover, onCreateDashboardClicked: this.handleCreateDashboardClicked, onOpenFoundationalTemplateModalClicked: this.handleOpenFoundationalTemplateModalClicked, elref: "browsePage", sort: browseParams.sort }) : ((_this$state$dashboard) => {
      const renderMainHeaderTitle = () => {
        return /* @__PURE__ */ React.createElement("div", { className: "query-report-title-container", "data-sentry-component": "renderMainHeaderTitle", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ React.createElement(QueryReportTitleReact, { ...headerParamsToTitleProps(_objectSpread(_objectSpread({}, this.buildQueryReportHeaderParams()), {}, {
          onSave: this.handleHeaderSave
        })), "data-sentry-element": "QueryReportTitleReact", "data-sentry-source-file": "template.tsx" }));
      };
      return /* @__PURE__ */ React.createElement(React.Fragment, null, renderMainHeaderTitle(), ((_this$state$dashboard = this.state.dashboard) === null || _this$state$dashboard === void 0 ? void 0 : _this$state$dashboard.template_type) === TemplateType.BENCHMARK_KPI && /* @__PURE__ */ React.createElement(BenchmarkTemplateBanner, null), /* @__PURE__ */ React.createElement("div", { className: "cards-container", onClick: this.toggleRHSReminderTooltip }, dashboardFailed ? null : dashboardLoaded ? /* @__PURE__ */ React.createElement(GridRows, { availableCards: this.getAvailableCards(), canEditActiveDashboard: this.canEditActiveDashboard(), cards: this.state.cards, dashboard: this.state.dashboard, dashboardLoaded: this.state.dashboardLoaded, getDashboardCardComponentOptions: this.getDashboardCardComponentOptions, getSparkCardComponentOptions: this.getSparkCardComponentOptions, gridLayout: this.getGridLayout(), isLayoutBeingUpdated: this.isLayoutBeingUpdated(), projectId: this.props.context.projectId, userId: this.props.context.userId, workspaceId: this.props.context.workspaceId, onContentAction: this.handleContentAction, onGridInsert: this.handleGridInsert, onGridTrackEvent: this.handleGridTrackEvent, onLayoutUpdate: this.handleLayoutUpdate, onOpenFoundationalTemplateModalClicked: this.handleOpenFoundationalTemplateModalClicked, seenCards: this.state.seenCards, isRHSHoverOnly: this.shouldDisableGridRowClick() }) : /* @__PURE__ */ React.createElement("div", { className: "reports-loading" }, /* @__PURE__ */ React.createElement(SpinnerReact, null))));
    })());
  };
  const renderReportEditor = () => {
    return /* @__PURE__ */ React.createElement("div", { className: clsx("editor-card", "inherit-size"), "data-sentry-component": "renderReportEditor", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ React.createElement(ReportEditorReact, { className: clsx("report-editor-el", "inherit-size"), editorParams: {
      bookmarkURLSlug: editorCardBookmarkURLSlug,
      dashboardCardId: isStagedCardId(this.state.editorCardId) ? null : this.state.editorCardId,
      dashboardOverrides: this.getEditorBookmarkOverrides(),
      defaultBookmarkType: this.getBookmarkTypeFromCardId(),
      editedBookmark: this.getEditorBookmark(),
      isFasteditPageload: this.state.isFasteditPageload,
      longUrlCount: this.state.editedBookmarkLongUrlCount,
      originalBookmark: this.getEditorCardOriginalBookmark(),
      resultsPromise: foregroundQueryResults.get(editorCardId),
      setResultsInDashboardCallback: this.setResultsInDashboardCallback.bind(this, this.state.editorCardId)
    }, elref: "reportEditor", loading: this.isLoadingEditorBookmark(), isSavingBookmark: this.state.isSavingEditorBookmark, originDashboard: this.getDashboardParams(this.state.dashboard, true), dashboardsRoute: getRouteToCurrentDashboard({
      dashboard: this.state.dashboard,
      includeCurrentDashboard: true
    }), onBackToBoard: this.handleReportEditorBackToBoard, onDelete: this.handleReportEditorDelete, onSave: this.handleReportEditorSave, onMove: this.handleReportEditorMove, onUpdate: this.handleReportEditorUpdate, "data-sentry-element": "ReportEditorReact", "data-sentry-source-file": "template.tsx" }));
  };
  const renderFilterBar = () => {
    if (!dashboardLoaded) {
      return false;
    }
    return /* @__PURE__ */ React.createElement(ReactErrorBoundary, { "data-sentry-element": "ReactErrorBoundary", "data-sentry-component": "renderFilterBar", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ React.createElement(FilterBar, { areFiltersChanged: this.areGlobalOptionsChanged(), canEditActiveDashboard: this.canEditActiveDashboard(), canUseCohorts: this.canUseCohorts(), canUseDataGroups: this.canUseDataGroups(), filters: this.state.filters, breakdowns: this.state.breakdowns, isMinimalMode: this.isMinimalMode(), maxHistoryDays: this.getMaxDataHistoryDays(), projectAsOfDate: this.getProjectAsOfDate(), projectId: this.props.context.projectId, timeFilter: this.state.timeFilter, userId: this.props.context.userId, workspaceId: this.props.context.workspaceId, onChangeGlobalFilters: this.updateGlobalFilters, onChangeGlobalBreakdowns: this.updateGlobalBreakdowns, onChangeGlobalTimeFilter: this.updateGlobalTimeFilter, onClearGlobalTimeFilter: this.clearTimeFilter, onDiscardBoardsFilters: this.handleBoardsDiscardFilters, onSaveBoardsFilters: this.handleBoardsSaveFilters, onTrackGlobalFilters: this.handleGlobalFilterBarTrack, "data-sentry-element": "FilterBar", "data-sentry-source-file": "template.tsx" }));
  };
  return /* @__PURE__ */ React.createElement("div", { className: clsx("standard-mode-wrapper", {
    "is-embed": this.state.isEmbedMode,
    "inherit-size": true
  }), ref: this.containerRef, elref: this.props.elref, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ React.createElement(BackboneStyleRoutes, { routes: {
    ":hashParams": this.handleHashRoutes,
    "": this.handleIndexRoute
  }, "data-sentry-element": "BackboneStyleRoutes", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ React.createElement("div", { className: clsx("standard-mode", {
    "inherit-size": true,
    "fast-edit-report-open": this.showFastEditReport(),
    "minimal-mode": this.isMinimalMode(),
    "hide-border": this.isMinimalMode()
  }) }, /* @__PURE__ */ React.createElement("div", { className: clsx("standard-mode-content-container", "inherit-size") }, !this.isMinimalMode() && !(browseParams !== null && browseParams !== void 0 && browseParams.isBrowseMode) && /* @__PURE__ */ React.createElement("div", { className: "report-header-container" }, renderDashboardHeader()), /* @__PURE__ */ React.createElement("div", { className: "global-filter-sticky-container" }, renderFilterBar()), /* @__PURE__ */ React.createElement(BannerLayout, { className: "standard-mode-content", revealedBannerIdentifiers: this.state.revealedBannerIdentifiers, "data-sentry-element": "BannerLayout", "data-sentry-source-file": "template.tsx" }, this.isMinimalMode() && // for minimal mode, render header inside content layout so that it has side padding and it's
  // scrollable rather than sticky
  renderDashboardHeader(), renderDashboardContent())), renderRHSPanel()), this.showFastEditReport() && renderReportEditor());
}
